export { useCustomerData } from './useCustomerData';
